import { render, staticRenderFns } from "./BJ.vue?vue&type=template&id=a50f39c4&scoped=true"
import script from "./BJ.vue?vue&type=script&lang=js"
export * from "./BJ.vue?vue&type=script&lang=js"
import style0 from "./BJ.vue?vue&type=style&index=0&id=a50f39c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50f39c4",
  null
  
)

export default component.exports